(() => {
  const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  if (!isMobile) return;

  function tryPlayFrom(container) {
    if (!container) return;

    // Shopify hosted video: <video>
    const video = container.querySelector('video');
    if (video) {
      // iOS/Safari precisa disso pra tocar inline
      video.setAttribute('playsinline', '');
      video.playsInline = true;

      // Não força muted (pra não mudar sua intenção), só tenta tocar.
      const p = video.play?.();
      if (p && typeof p.catch === 'function') p.catch(() => {});
      return;
    }

    // External (YouTube/Vimeo) via iframe: não dá play confiável por JS sem API
    // então aqui só garantimos o load do conteúdo (feito abaixo).
  }

  function loadDeferredMedia(deferred) {
    if (!deferred) return;

    // Dawn usa <deferred-media> com método loadContent() em muitas versões.
    if (typeof deferred.loadContent === 'function') {
      deferred.loadContent();
      return;
    }

    // Fallback: clicar no botão do poster (se existir)
    const btn = deferred.querySelector('.deferred-media__poster-button');
    if (btn) btn.click();
  }

  // Captura o toque/click no poster (mesmo se algum overlay atrapalhar o bubble)
  document.addEventListener(
    'pointerup',
    (e) => {
      const posterBtn = e.target.closest('.deferred-media__poster-button');
      if (!posterBtn) return;

      const deferred = posterBtn.closest('deferred-media');
      if (!deferred) return;

      // Carrega o conteúdo do vídeo
      loadDeferredMedia(deferred);

      // Aguarda o DOM inserir <video> e tenta play
      requestAnimationFrame(() => {
        tryPlayFrom(deferred);
        // segunda tentativa (alguns devices inserem o video um tick depois)
        setTimeout(() => tryPlayFrom(deferred), 120);
      });
    },
    true // capture = true (importante)
  );

  // Também cobre o caso do usuário tocar na área do poster (não exatamente no botão)
  document.addEventListener(
    'pointerup',
    (e) => {
      const poster = e.target.closest('deferred-media .deferred-media__poster');
      if (!poster) return;

      const deferred = poster.closest('deferred-media');
      if (!deferred) return;

      loadDeferredMedia(deferred);

      requestAnimationFrame(() => {
        tryPlayFrom(deferred);
        setTimeout(() => tryPlayFrom(deferred), 120);
      });
    },
    true
  );
})();
